import { clearAccessToken } from './accessToken';

const TOKEN_EXPIRY_BUFFER_MS = 60 * 1000;

export const decodeJwtPayload = (token) => {
  try {
    const base64Payload = token.split('.')[1];
    const payload = atob(base64Payload);
    return JSON.parse(payload);
  } catch (error) {
    return null;
  }
};

export const isTokenExpired = (token) => {
  if (!token) return true;

  const payload = decodeJwtPayload(token);
  if (!payload || !payload.exp) return true;

  const expirationTime = payload.exp * 1000;
  const now = Date.now();

  return now >= expirationTime - TOKEN_EXPIRY_BUFFER_MS;
};

export const getTokenExpirationTime = (token) => {
  if (!token) return null;

  const payload = decodeJwtPayload(token);
  if (!payload || !payload.exp) return null;

  return new Date(payload.exp * 1000);
};

export const clearAuthData = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('CONSOLIDATED_ASSETS_BY_TYPE');
  clearAccessToken();
};
